export default __webpack_public_path__ + "static/media/casino-hover.4b223ae3.webp";